import {Component, OnInit} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import {default as _rollupMoment} from 'moment';

const moment = _rollupMoment || _moment;

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

/** @title Datepicker with custom formats */
@Component({
  selector: 'datepicker-formats-example',
  template: `
  <mat-form-field>
   <input matInput [max]="maxDate" [matDatepicker]="dp" [(ngModel)]="dateEntry" placeholder="Select Date" [formControl]="dateCtr">
   <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
   <mat-datepicker #dp></mat-datepicker>
   <mat-error align="end" *ngIf="dateCtr.hasError('required')">
   a valid date mm/dd/yyyy is required
   </mat-error>

 </mat-form-field>
  `,
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class DatepickerComponent implements OnInit{
  dateEntry;
  dateCtr = new FormControl(moment(),Validators.required); 
  maxDate = moment();

  ngOnInit(){
    this.dateEntry = new Date();
  }

  // getDate(){
  //   Date.
  //   return this.dateEntry.toString()
  // }
    
}